import React, { useMemo } from 'react'
import FeaturesSection from '../../UAEPages/UAEPageComponents/FeaturesSection'
import { INDGestaurantsFeatures, OtherFeaturesDataRestaurantsInd, OutletTypesDataRestaurantsInd } from '../../../constants/common'
import HeaderSection from '../../UAEPages/UAEPageComponents/HeaderSection'
import OtherFeatures from '../../UAEPages/UAEPageComponents/OtherFeatures'
import OutletTypes from '../../UAEPages/UAEPageComponents/OutletTypes'
import styles from '../../../styles/UAEPageComponents.module.css'
import NewFaqSection from '@/components/HomeLanding/HomeLandingComponents/NewFaqSection'
import BusinessUnlockSection from '@/components/HomeLanding/ComponentsIndiaPage/BusinessUnlockSection'
import ConnectWithUs from '@/components/HomeLanding/ComponentsIndiaPage/ConnectWithUs'
import AwardsSection from '@/components/HomeLanding/HomeLandingComponents/AwardsSection'
import NewsAndVideos from '@/components/HomeLanding/ComponentsIndiaPage/NewsAndVideos'
import ContqactSection from '../../UAEPages/UAEPageComponents/ContactSection'

const DesktopRestaurants = () => {
  const INRestaurantsHeader = useMemo(() => ({
    useIndiaLogos: true,
    firstTitle: "The Next-Gen POS Billing Software for",
    secondTitle: "Restaurant Operations",
    description: "Managing a restaurant means juggling dozens of tables, a live kitchen, multiple order channels, and a line of hungry guests, all at once. Turn every meal into a memorable experience for your customers. QueueBuster brings it all under one powerful billing and restaurant management software. From lightning-fast billing at the counter to real-time kitchen coordination, QueueBuster keeps your restaurant running at full speed, even during your busiest lunch and dinner rushes.",
    images: {
      bgVector: "/assets/UAERetailPage/bgVector.svg",
      bgwidth: "50rem",
      bgheight: "45rem",
      bgtop: "5%",
      bgleft: "14%",
      bgbottom: "10%",
      bgright: "10%",
      bgzindex: "0",
      mainImage: {
        src: "/assets/uae-restaurants/restaurant_mainImg.webp",
        alt: "QueueBuster for Restaurants",
        width: "45rem",
        height: "40rem",
        bottom: "0",
        right: "0"
      },
      img1: {
        src: "/assets/restaurantsInd/Schedule.svg",
        alt: "Quick Bill",
        width: "17rem",
        height: "17rem",
        top: "5rem",
        left: "10%",
        zindex: 0
      },
      img2: {
        src: "/assets/uae-restaurants/discount.svg",
        alt: "Schedule",
        width: "15rem",
        height: "5.5rem",
        bottom: "35%",
        left: "5%",
        zindex: 10
      },
      img3: {
        src: "/assets/uae-restaurants/Frame.svg",
        alt: "Plane Image",
        width: "28rem",
        height: "18rem",
        top: "0%",
        right: "-4rem"
      },
      strVector1: {
        src: "/assets/UAERetailPage/Vector.svg",
        alt: "Vector 1",
        width: "2rem",
        height: "2rem",
        top: "18.5%",
        left: "30%"
      },
      strVector3: {
        src: "/assets/UAERetailPage/Vector2.svg",
        alt: "Vector 3",
        width: "2rem",
        height: "2rem",
        bottom: "25%",
        right: "-3%"
      },
    }
  }), [])

 

  const faqs = [
    {
      para: (
        <span style={{ width: "90%" }}>
          What makes QueueBuster the ideal billing solution for restaurants?
        </span>
      ),
      des: "QueueBuster is purpose-built to handle the unique operational demands of restaurants, from managing high-volume dine-in orders and live kitchen workflows to running multiple delivery channels, loyalty programs, and inventory tracking simultaneously. Unlike generic POS systems, QueueBuster offers restaurant-specific features like KOT management, table mapping, and omnichannel order consolidation. Its intuitive interface requires minimal staff training, making it easy to deploy across every format, from a fast-moving QSR counter to a full-service fine dining floor.",
      id: 1,
      activeIndex: 1,
    },
    {
      para: (
        <span style={{ width: "90%" }}>
          Which restaurant formats does QueueBuster support?
        </span>
      ),
      des: "QueueBuster is built for every restaurant format. Whether you run a QSR, café, cloud kitchen, fine dining restaurant, bakery, sweet shop, food court, or food truck, QueueBuster adapts to your specific operational needs. Its flexible configuration lets you customize table layouts, menu structures, KOT flows, and billing modes to suit exactly how your restaurant works, regardless of format or scale.",
      id: 2,
      activeIndex: 0,
    },
    {
      para: (
        <span style={{ width: "90%" }}>
          How does QueueBuster handle orders from Zomato, Swiggy, and other platforms?
        </span>
      ),
      des: "QueueBuster integrates directly with Zomato, Swiggy, and other major food ordering platforms, pulling all incoming delivery orders into a single centralized dashboard alongside your dine-in and takeaway orders. This eliminates the need to manage multiple tablets or manually relay orders to the kitchen. Menus, prices, and availability are synced in real time across all platforms, so what guests see online always matches what your kitchen can deliver.",
      id: 3,
      activeIndex: 0,
    },
    {
      para: (
        <span style={{ width: "90%" }}>
          Can QueueBuster manage multiple outlets from one system?
        </span>
      ),
      des: "Yes. QueueBuster is designed for both single-outlet operations and growing multi-location restaurant brands. You can manage menus, pricing, and inventory across all your outlets from a central dashboard, with outlet-wise performance reports giving you a clear view of what's working where. For cloud kitchen operators running multiple virtual brands from one kitchen, QueueBuster handles separate KOT and billing flows for each brand without any confusion.",
      id: 4,
      activeIndex: 0,
    },
    {
      para: (
        <span style={{ width: "90%" }}>
          How does the KOT and kitchen workflow feature work?
        </span>
      ),
      des: "When a staff member punches an order in QueueBuster, a Kitchen Order Ticket is instantly sent to the kitchen via a KOT printer or Kitchen Display System. This eliminates verbal communication errors and gives the kitchen a clear, prioritized view of pending orders at all times. Staff can update order status in real time, helping the front of house know exactly when dishes are ready, reducing wait times and improving table turnaround significantly.",
      id: 5,
      activeIndex: 0,
    },
    {
      para: (
        <span style={{ width: "90%" }}>
          Does QueueBuster support loyalty programs and customer engagement?
        </span>
      ),
      des: "Yes. QueueBuster has a built-in CRM and loyalty engine that lets you track customer visits, spending patterns, and preferences over time. You can set up point-based loyalty programs, offer member discounts, run birthday or anniversary campaigns, and push targeted offers to specific customer segments, all without needing a separate marketing tool.",
      id: 6,
      activeIndex: 0,
    },
    {
      para: (
        <span style={{ width: "90%" }}>
          How quickly can QueueBuster be set up at my restaurant?
        </span>
      ),
      des: "QueueBuster is designed for fast, smooth deployment with minimal disruption to your daily service. Our dedicated onboarding team works with your management to understand your outlet structure, menu configuration, and operational requirements before setting everything up. Staff training is short and simple thanks to QueueBuster's intuitive interface; most teams are fully operational within just a couple of days. We also provide ongoing technical support and regular software updates to ensure your POS always performs at its best, whether it's a quiet Tuesday afternoon or a packed Saturday night.",
      id: 7,
      activeIndex: 0,
    },
  ]

  return (
    <div style={{ fontFamily: 'GilroyMedium' }}>
      <HeaderSection data={INRestaurantsHeader} />

      <FeaturesSection
        data={INDGestaurantsFeatures}
        title={"Sizzling Features of Billing Software For Restaurants!"} />

      <OtherFeatures
        data={OtherFeaturesDataRestaurantsInd}
        title={<>Other Important Features for <br />Restaurant POS Software</>} />

      <OutletTypes title={"Restaurants Types"} data={OutletTypesDataRestaurantsInd} />

      <div className={styles.resposiveSections}>
        <AwardsSection />
        <div><BusinessUnlockSection /></div>
        <div><ConnectWithUs /></div>
      </div>
      <div><NewFaqSection FaqTableData={faqs} heading={"FAQs for Restaurant POS Software"} /></div>

      <div>
        <ContqactSection
          title="Couldn’t Find What You Wanted?"
          description={<>Worry not, just send us your inquiry and wait while our Restaurant POS <br /> experts contact you.</>}
          buttonText="Request a callback"
        />
      </div>

      <div>
        <NewsAndVideos />
      </div>
    </div>
  )
}

export default DesktopRestaurants
